import {AfriexKYCProcessor, KYC_ROUTING_KEYS} from '@afriex/core/domain/enums';

/**
 * Human labels for the KYC routing keys.
 *
 * These are the vocabulary `VerificationProcessorSelector.selectByName`
 * accepts, not the `AfriexKYCProcessor` enum: config routes Smile ID as
 * `'smileID'`, which is not an enum member. `patchCountrySchema` validates
 * against the same `KYC_ROUTING_KEYS` list, so anything offered here is
 * accepted on write.
 */
export const KYC_PROCESSOR_LABELS: Record<string, string> = {
  okra: 'Okra',
  veriff: 'Veriff',
  smileID: 'Smile ID',
  sumsub: 'SumSub',
  aiprise: 'AiPrise',
  stripe: 'Stripe Identity',
  [AfriexKYCProcessor.StripeIdentity]: 'Stripe Identity (legacy key)',
};

/**
 * The selector resolves both `'stripe'` and the
 * `AfriexKYCProcessor.StripeIdentity` (`'stripe_identity'`) enum value to the
 * same processor, so offering both would be two options that do the same
 * thing. `'stripe'` is what config used and what the backfill wrote, so it is
 * the canonical choice; the legacy key is only surfaced when a country already
 * holds it.
 */
export const CANONICAL_KYC_KEYS = KYC_ROUTING_KEYS.filter(
  (key) => key !== AfriexKYCProcessor.StripeIdentity,
);

/**
 * A country's configured processor rendered for display. Falls back to the raw
 * value so a key this build has no label for still shows as itself rather than
 * appearing unset.
 */
export const formatKycProcessor = (processor?: string): string =>
  processor ? (KYC_PROCESSOR_LABELS[processor] ?? processor) : 'Not set';
